import { BORDER, INK, LAYOUT, RADIUS, STATUS_HEX, SURFACE } from '../../design-system/foundation';

/**
 * Shared matte workspace surface — used by Understand cognition space and Discover pages.
 * Hairline borders, flat panels, no glass/glow chrome.
 *
 * Neutrals are theme-aware CSS variables (they used to be dark-only hex, which
 * broke light mode). They are page chrome, not graph stages — for an
 * always-dark diagram stage use `SURFACE.stage` from design-system/foundation.
 * Don't pass these through MUI `alpha()` (it throws on `var()`); use
 * `safeAlpha` from design-system/tokens.
 */
export const WORKSPACE_SURFACE = {
  canvas: SURFACE.app,
  canvasDeep: SURFACE.panel,
  panel: SURFACE.panel,
  panelRaised: SURFACE.card,

  hairline: BORDER.subtle,
  hairlineStrong: BORDER.default,

  text: INK.primary,
  textSecondary: INK.secondary,
  textMuted: INK.tertiary,

  /** Literal hex — fills, dots, icons. */
  positive: STATUS_HEX.success,
  info: STATUS_HEX.info,
} as const;

/** Card-style frame around a workspace section (theme-aware). */
export const stageShellSx = {
  borderRadius: `${RADIUS.card}px`,
  border: `1px solid ${BORDER.default}`,
  bgcolor: SURFACE.panel,
  overflow: 'hidden' as const,
};

/**
 * Horizontal padding for the project workspace (home and section pages).
 * The app shell drops its own padding inside the project workspace, so this
 * mirrors the shell value to keep every screen aligned.
 */
export const WORKSPACE_CHROME_PAD = LAYOUT.pagePadX;
